import { useResponsive } from '../../hooks/useResponsive';
import { MobileUserSettingsNavigation } from './components/mobile-user-settings-navigation';
import { ProfilePage } from './profile.page';

export const AccountRoute = () => {
  const { isMobile } = useResponsive();
  return isMobile ? <MobileUserSettingsNavigation /> : <ProfilePage />;
};
